var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "login-title" }, [
      _vm._v("空调智能化软件管理系统")
    ]),
    _vm._v(" "),
    _c("a", { staticClass: "login-btn", attrs: { href: _vm.LOGIN_URL } }, [
      _vm._v("mip账号登录")
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "text-align": "left" } }, [
      _c("img", {
        staticClass: "login-logo",
        attrs: { src: require("../assets/images/login_logo.png") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }